(function () {
  function readNonNegativeInt(element, attributeName, fallback) {
    const raw = element && element.getAttribute(attributeName);
    const parsed = parseInt(raw, 10);
    if (isNaN(parsed) || parsed < 0) return fallback;
    return parsed;
  }

  function readAriaMaxCents(progressRoot) {
    const max = readNonNegativeInt(progressRoot, 'data-max-goal-cents', 0);
    return max > 0 ? max : 1;
  }

  function fillPercentWhenShippingThenGift(cartTotalCents, shippingThresholdCents, giftThresholdCents) {
    if (cartTotalCents < shippingThresholdCents) {
      return (cartTotalCents / shippingThresholdCents) * 50;
    }
    if (cartTotalCents < giftThresholdCents) {
      const rangeAfterShipping = giftThresholdCents - shippingThresholdCents;
      const centsPastShipping = cartTotalCents - shippingThresholdCents;
      return 50 + (centsPastShipping / rangeAfterShipping) * 50;
    }
    return 100;
  }

  function fillPercentWhenOnlyGiftThreshold(cartTotalCents, giftThresholdCents) {
    if (cartTotalCents < giftThresholdCents) {
      return (cartTotalCents / giftThresholdCents) * 100;
    }
    return 100;
  }

  function fillPercentWhenOnlyShipping(cartTotalCents, shippingThresholdCents) {
    if (shippingThresholdCents <= 0) {
      return 100;
    }
    if (cartTotalCents < shippingThresholdCents) {
      return (cartTotalCents / shippingThresholdCents) * 100;
    }
    return 100;
  }

  function fillPercentProportionalToLargerThreshold(cartTotalCents, shippingThresholdCents, giftThresholdCents) {
    const referenceCents = Math.max(shippingThresholdCents, giftThresholdCents, 1);
    return Math.min(100, (cartTotalCents / referenceCents) * 100);
  }

  function calculateFillWidthPercent(cartTotalCents, shippingThresholdCents, giftThresholdCents, isGiftEnabled) {
    const total = Math.max(0, cartTotalCents);

    if (isGiftEnabled && giftThresholdCents > shippingThresholdCents && shippingThresholdCents > 0) {
      return fillPercentWhenShippingThenGift(total, shippingThresholdCents, giftThresholdCents);
    }

    if (isGiftEnabled && shippingThresholdCents <= 0 && giftThresholdCents > 0) {
      return fillPercentWhenOnlyGiftThreshold(total, giftThresholdCents);
    }

    if (!isGiftEnabled) {
      return fillPercentWhenOnlyShipping(total, shippingThresholdCents);
    }

    return fillPercentProportionalToLargerThreshold(total, shippingThresholdCents, giftThresholdCents);
  }

  function updateProgressBar(progressRoot, cartTotalCentsFromEvent) {
    if (!progressRoot) return;

    const cartTotalCents =
      typeof cartTotalCentsFromEvent === 'number' && !isNaN(cartTotalCentsFromEvent)
        ? cartTotalCentsFromEvent
        : readNonNegativeInt(progressRoot, 'data-total-cents', 0);

    progressRoot.setAttribute('data-total-cents', String(cartTotalCents));

    const shippingThresholdCents = readNonNegativeInt(progressRoot, 'data-shipping-threshold-cents', 0);
    const giftThresholdCents = readNonNegativeInt(progressRoot, 'data-gift-threshold-cents', 0);
    const isGiftEnabled = progressRoot.getAttribute('data-gift-enabled') === 'true';

    const fillWidthPercent = calculateFillWidthPercent(
      cartTotalCents,
      shippingThresholdCents,
      giftThresholdCents,
      isGiftEnabled
    );

    const progressFill = progressRoot.querySelector('.checkout-progress-fill');
    if (progressFill) {
      progressFill.style.width = fillWidthPercent + '%';
      progressFill.setAttribute('aria-valuenow', String(cartTotalCents));
      progressFill.setAttribute('aria-valuemax', String(readAriaMaxCents(progressRoot)));
    }

    const shippingMilestone = progressRoot.querySelector('[data-milestone="shipping"]');
    if (shippingMilestone) {
      const shippingUnlocked = shippingThresholdCents <= 0 || cartTotalCents >= shippingThresholdCents;
      shippingMilestone.classList.toggle('active', shippingUnlocked);
    }

    const giftMilestone = progressRoot.querySelector('[data-milestone="gift"]');
    if (giftMilestone && isGiftEnabled) {
      const giftUnlocked = giftThresholdCents > 0 && cartTotalCents >= giftThresholdCents;
      giftMilestone.classList.toggle('active', giftUnlocked);
    }
  }

  function onCartUpdated(payload) {
    const progressRoot = document.getElementById('cart-drawer-checkout-progress');
    if (!progressRoot) return;

    const cart = payload && payload.cartData;
    const cartTotalCents =
      cart && typeof cart.total_price === 'number'
        ? cart.total_price
        : readNonNegativeInt(progressRoot, 'data-total-cents', 0);

    updateProgressBar(progressRoot, cartTotalCents);
  }

  function init() {
    const progressRoot = document.getElementById('cart-drawer-checkout-progress');
    if (progressRoot) {
      updateProgressBar(progressRoot, readNonNegativeInt(progressRoot, 'data-total-cents', 0));
    }

    if (
      window.__cartDrawerProgressBound ||
      typeof subscribe === 'undefined' ||
      typeof PUB_SUB_EVENTS === 'undefined'
    ) {
      return;
    }

    window.__cartDrawerProgressBound = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
